import Alert_module_default from "./Alert.module.js";
import { Text } from "../Typography/Text.js";
import { IconButton } from "../Button/IconButton/IconButton.js";
import classNames from "classnames";
import { useCallback } from "react";
import CheckCircleIcon from "@vector-im/compound-design-tokens/assets/web/icons/check-circle";
import ErrorIcon from "@vector-im/compound-design-tokens/assets/web/icons/error-solid";
import InfoIcon from "@vector-im/compound-design-tokens/assets/web/icons/info";
import CloseIcon from "@vector-im/compound-design-tokens/assets/web/icons/close";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Alert/Alert.tsx
/**
* An alert component component that is dismissable when passing an `onClose`
* property.
*/
var Alert = ({ type, title, children, className, actions, onClose, ...props }) => {
	const classes = classNames(Alert_module_default.alert, className);
	const renderIcon = useCallback((props) => {
		switch (type) {
			case "critical": return /* @__PURE__ */ jsx(ErrorIcon, { ...props });
			case "info": return /* @__PURE__ */ jsx(InfoIcon, { ...props });
			case "success": return /* @__PURE__ */ jsx(CheckCircleIcon, { ...props });
		}
	}, [type]);
	return /* @__PURE__ */ jsxs("div", {
		...props,
		className: classes,
		"data-type": type,
		children: [
			renderIcon({
				width: 24,
				height: 24,
				className: Alert_module_default.icon,
				"aria-hidden": true
			}),
			/* @__PURE__ */ jsxs("div", {
				className: Alert_module_default.content,
				children: [/* @__PURE__ */ jsxs("div", {
					className: Alert_module_default["text-content"],
					children: [/* @__PURE__ */ jsx(Text, {
						size: "md",
						weight: "semibold",
						children: title
					}), /* @__PURE__ */ jsx(Text, {
						size: "sm",
						weight: "regular",
						children
					})]
				}), actions && /* @__PURE__ */ jsx("div", {
					className: Alert_module_default.actions,
					children: actions
				})]
			}),
			onClose && /* @__PURE__ */ jsx(IconButton, {
				onClick: onClose,
				"aria-label": "Close",
				role: "button",
				className: Alert_module_default.close,
				children: /* @__PURE__ */ jsx(CloseIcon, {})
			})
		]
	});
};
//#endregion
export { Alert };

//# sourceMappingURL=Alert.js.map